class AccordionItem {
    constructor(el, accordion) {
        this.accordion = accordion;
        this.blockElement = el;
        this.content = el.querySelector('.accordion-item__body');
        this.contentWrapper = el.querySelector('.accordion-item__content');
        this.toggleButton = el.querySelector('.js-accordion-toggle');
        this.contentHeight = 0;
        this.isOpen = true;
        this.init();
    }
    init() {
        this.hideContent();
        this.calcHeight();
        this.addListeners();
    }
    calcHeight() {
        this.contentHeight = this.contentWrapper.offsetHeight;
    }
    hideContent() {
        this.blockElement.classList.remove('is-open');
        this.content.style.maxHeight = 0;
        this.isOpen = false;
    }
    showContent() {
        this.blockElement.classList.add('is-open');
        this.content.style.maxHeight = this.contentHeight + 'px';
        this.isOpen = true;
    }
    handleClick() {
        this.accordion.onAccordionClick(this);
    }
    addListeners() {
        this.toggleButton.addEventListener('click', this.handleClick.bind(this));
        window.addEventListener('resize', this.calcHeight.bind(this));
    }
}
class Accordion {
    constructor(el) {
        this.accordionElements = el.querySelectorAll('.js-accordion-item');
        this.accordionItems = [];
        if (this.accordionElements.length > 0) {
            this.init();
        }
        this.onAccordionClick = this.onAccordionClick.bind(this);
    }
    init() {
        this.accordionElements.forEach(el => {
            this.accordionItems.push(new AccordionItem(el, this));
        });
        //console.log(this.accordionItems);
    }
    onAccordionClick(target) {
        //console.log(target);
        if (target.isOpen) {
            target.hideContent();
        } else {
            //console.log(this);
            this.accordionItems.map(item => {
                item.isOpen ? item.hideContent() : '';
            });
            target.showContent();
        }
    }
}
const accordions = document.querySelectorAll('.js-accordion');
if (accordions) {
    accordions.forEach((el) => {
       new Accordion(el);
    });
}